module.exports = __webpack_public_path__ + "img/gp.0233a18f.svg";